import React from 'react';
import ServerForm from '../../components/server/ServerForm';

const EditServerPage = () => {
  return (
    <div>
      <ServerForm editMode={true} />
    </div>
  );
};

export default EditServerPage;